// extracted by mini-css-extract-plugin
export default {"active":"TabNavItem_active__0-iL2","normal":"TabNavItem_normal__mcvvG"};